import { EntityMapping } from "./EntityMapping";
import { ClassFieldReader, EntityFieldReader } from "./FieldReader";
import { EntitySerializer } from "./EntitySerializer";
import { Optional } from "../Optional";
var Base = (function () {
    function Base() {
    }
    Base['__attributes'] = function () {
        return this;
    };
    Base.create = function (args) {
        var instance = this.build(args);
        instance.validate();
        return instance;
    };
    Base.build = function (args) {
        var instance = new this();
        new EntityMapping(instance, args).map();
        return instance;
    };
    Base.fields = function () {
        return new ClassFieldReader(this);
    };
    Base.prototype.writeClean = function (args) {
        new EntityMapping(this, args).map();
        this.validate();
        return this;
    };
    Base.prototype.writePartial = function (args) {
        new EntityMapping(this, args).map({ onlyProvided: true });
        return this;
    };
    Base.prototype.fields = function () {
        return new EntityFieldReader(this);
    };
    Base.prototype.serialize = function () {
        return new EntitySerializer(this);
    };
    Base.prototype.validate = function () { };
    Base.fromJSON = function (data) {
        return this.create(data);
    };
    Base.prototype.toJSON = function () {
        return this.asJSON();
    };
    Base.prototype.asJSON = function () {
        return this.serialize().asJSON();
    };
    Base.prototype.maybe = function (value) {
        return Optional.of(this[value]);
    };
    Base.prototype.__attributes = function () {
        throw new TypeError('Do not access Entity.Base.Symbol<AttributeTypeKey>');
    };
    return Base;
}());
export { Base };
export function isEntityConstructor(o) {
    var _a;
    return o === Base || ((_a = o) === null || _a === void 0 ? void 0 : _a.prototype) instanceof Base;
}
